import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardProductRadio from 'components/CardProduct/CardProductRadio';

class CardProductContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptionIndex: -1,
      modalOpt: undefined,
      isOpen: false,
    };

    this.click = this.click.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  onAfterClose = () => {
    this.setState({ modalOpt: undefined });
  }

  toggleModal(e, modalOpt, isOpen) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isOpen });
    if (isOpen) {
      this.setState({ modalOpt });
    }
  }

  click(e, optIndex) {
    const { selectedOptionIndex } = this.state;
    const isSelected = selectedOptionIndex === optIndex;
    return isSelected ? this.setState({ selectedOptionIndex: -1 }) : this.setState({ selectedOptionIndex: optIndex });
  }

  render() {
    const { items = [], itemType = 'CardProductDItem', gridClass = '', groupByCategory = false } = this.props;
    const { selectedOptionIndex, modalOpt, isOpen } = this.state;

    return (
      <CardProductRadio
        items={items}
        selectedOptionIndex={selectedOptionIndex}
        modalOpt={modalOpt}
        isOpen={isOpen}
        click={this.click}
        toggleModal={this.toggleModal}
        itemType={itemType}
        gridClass={gridClass}
        groupByCategory={groupByCategory}
      />
    );
  }
}

CardProductContainer.propTypes = {
  items: PropTypes.array.isRequired,
  itemType: PropTypes.string,
  gridClass: PropTypes.string,
  groupByCategory: PropTypes.bool,
};

export default CardProductContainer;
